<template>
  <div>
    <v-btn
      class="white--text"
      @click="addOrderItem()"
      :color="$store.state.currentOrg.org.primaryColour"
      round
      v-modal="addOrderButton"
      >ADD ORDER</v-btn
    >
    <v-dialog persistent width="1100px" v-model="addOrderButton">
      <v-toolbar flat :color="$store.state.currentOrg.org.primaryColour">
        <h1 class="headline white--text">FIBRE ORDER</h1>
        <v-spacer></v-spacer>
        <v-btn @click="addOrderButton = false" color="white" flat>X</v-btn>
      </v-toolbar>

      <v-stepper flat :alt-labels="altlabel" v-model="e1">
        <v-stepper-header :color="$store.state.currentOrg.org.primaryColour" class="elevation-0" style="height: 80px">
          <v-stepper-step
            :editable="editIfValidOperator"
            @click="stepOperator()"
            v-if="this.e1 >= 1 && this.max >= 1"
            style="font-size: 15px"
            :color="this.$store.state.currentOrg.org.primaryColour"
            :complete="e1 > 1"
            step="1"
          >
            <span :style="{ color: this.$store.state.currentOrg.org.primaryColour }" class="font-weight-bold"
              >Network Operator</span
            >
          </v-stepper-step>
          <v-stepper-step
            :editable="editIfValidOperator"
            @click="stepOperator()"
            v-else
            style="font-size: 12px"
            :complete="e1 > 1"
            step="1"
            >Network Operator</v-stepper-step
          >

          <v-divider></v-divider>

          <v-stepper-step
            :editable="editIfValidEstate"
            @click="stepEstate()"
            v-if="this.e1 >= 2 && this.max >= 2"
            style="font-size: 15px"
            :color="this.$store.state.currentOrg.org.primaryColour"
            :complete="e1 > 2"
            step="2"
          >
            <span :style="{ color: $store.state.currentOrg.org.primaryColour }" class="font-weight-bold"
              >Address Info</span
            >
          </v-stepper-step>
          <v-stepper-step
            :editable="editIfValidEstate"
            @click="stepEstate()"
            v-else-if="this.e1 <= 2 && this.max >= 2"
            style="font-size: 12px"
            :complete="e1 > 2"
            :color="this.$store.state.currentOrg.org.primaryColour"
            step="2"
          >
            <span :style="{ color: $store.state.currentOrg.org.primaryColour }">Address Info</span>
          </v-stepper-step>
          <v-stepper-step v-else style="font-size: 12px" :complete="e1 > 2" step="2">Address Info</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :editable="editIfValidPackage"
            @click="stepPackage()"
            v-if="this.e1 >= 3 && this.max >= 3"
            style="font-size: 15px"
            :complete="e1 > 3"
            :color="this.$store.state.currentOrg.org.primaryColour"
            step="3"
          >
            <span :style="{ color: $store.state.currentOrg.org.primaryColour }" class="font-weight-bold"
              >Choose Package</span
            >
          </v-stepper-step>
          <v-stepper-step
            :editable="editIfValidPackage"
            @click="stepPackage()"
            v-else-if="this.e1 <= 3 && this.max >= 3"
            style="font-size: 12px"
            :complete="e1 > 3"
            :color="this.$store.state.currentOrg.org.primaryColour"
            step="3"
          >
            <span :style="{ color: $store.state.currentOrg.org.primaryColour }">Choose Package</span>
          </v-stepper-step>
          <v-stepper-step v-else style="font-size: 12px" :complete="e1 > 3" step="3">Choose Package</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step
            :editable="editIfValidContact"
            @click="stepContact()"
            v-if="this.e1 >= 4 && this.max >= 4"
            style="font-size: 15px"
            :complete="e1 > 4"
            :color="this.$store.state.currentOrg.org.primaryColour"
            step="4"
          >
            <span :style="{ color: $store.state.currentOrg.org.primaryColour }" class="font-weight-bold"
              >Contact Info</span
            >
          </v-stepper-step>
          <v-stepper-step
            :editable="editIfValidContact"
            @click="stepContact()"
            v-else-if="this.e1 <= 4 && this.max >= 4"
            style="font-size: 12px"
            :complete="e1 > 4"
            :color="this.$store.state.currentOrg.org.primaryColour"
            step="4"
          >
            <span :style="{ color: $store.state.currentOrg.org.primaryColour }">Contact Info</span>
          </v-stepper-step>
          <v-stepper-step v-else style="font-size: 12px" :complete="e1 > 4" step="4">Contact Info</v-stepper-step>

          <v-divider></v-divider>
          <v-stepper-step
            :editable="editIfValidAdditional"
            @click="stepAdditional()"
            v-if="this.e1 >= 5 && this.max >= 5"
            style="font-size: 15px"
            :complete="e1 > 5"
            :color="this.$store.state.currentOrg.org.primaryColour"
            step="5"
          >
            <span :style="{ color: $store.state.currentOrg.org.primaryColour }" class="font-weight-bold"
              >Additional Info</span
            >
          </v-stepper-step>
          <v-stepper-step
            :editable="editIfValidAdditional"
            @click="stepAdditional()"
            v-else-if="this.e1 <= 5 && this.max >= 5"
            style="font-size: 12px"
            :complete="e1 > 5"
            :color="this.$store.state.currentOrg.org.primaryColour"
            step="5"
          >
            <span :style="{ color: $store.state.currentOrg.org.primaryColour }">Additional Info</span>
          </v-stepper-step>
          <v-stepper-step v-else style="font-size: 12px" :complete="e1 > 5" step="5">Additional Info</v-stepper-step>
          <v-divider></v-divider>

          <v-stepper-step
            :editable="editIfValidDate"
            @click="stepDate()"
            v-if="this.e1 >= 6 && this.max >= 6"
            style="font-size: 15px"
            :complete="e1 > 6"
            :color="this.$store.state.currentOrg.org.primaryColour"
            step="6"
          >
            <span :style="{ color: $store.state.currentOrg.org.primaryColour }" class="font-weight-bold"
              >Activation Date</span
            >
          </v-stepper-step>
          <v-stepper-step
            :editable="editIfValidDate"
            @click="stepDate()"
            v-else-if="this.e1 <= 6 && this.max >= 6"
            style="font-size: 12px"
            :complete="e1 > 6"
            :color="this.$store.state.currentOrg.org.primaryColour"
            step="6"
          >
            <span :style="{ color: $store.state.currentOrg.org.primaryColour }">Activation Date</span>
          </v-stepper-step>
          <v-stepper-step v-else style="font-size: 12px" :complete="e1 > 6" step="6">Activation Date</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card flat v-if="chooseOperator">
              <v-container style="text-align: center; padding-bottom: 0; margin-bottom: 0">
                <v-layout class="justify-center">
                  <v-flex xs7>
                    <v-autocomplete
                      class="pointer"
                      style="cursor: pointer"
                      clearable
                      v-model="detail.networkOperator"
                      :rules="[(v) => !!v || 'Network Operator is required']"
                      :items="networkOperators"
                      flat
                      v-on:change="setEstateList(detail.networkOperator)"
                      :color="$store.state.currentOrg.org.primaryColour"
                      label="Select your Network Operator"
                      item-text="organisation.name"
                      item-value="organisation"
                    ></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-layout>
                <v-spacer></v-spacer>

                <v-btn
                  class="justify-center white--text"
                  v-if="detail.networkOperator && detail.networkOperator.id && this.max == 1"
                  medium
                  round
                  @click="
                    max = 2;
                    e1 = 2;
                    chooseOperator = false;
                    chooseEstate = true;
                  "
                  :color="$store.state.currentOrg.org.primaryColour"
                >
                  NEXT
                  <v-icon>chevron_right</v-icon>
                </v-btn>
                <v-btn
                  class="white--text"
                  v-else-if="detail.networkOperator && detail.networkOperator.id && this.max != 1"
                  medium
                  round
                  @click="
                    e1 = 2;
                    chooseOperator = false;
                    chooseEstate = true;
                  "
                  :color="$store.state.currentOrg.org.primaryColour"
                >
                  NEXT
                  <v-icon>chevron_right</v-icon>
                </v-btn>
                <v-btn
                  class="white--text"
                  v-else
                  medium
                  round
                  disabled
                  :color="$store.state.currentOrg.org.primaryColour"
                >
                  NEXT
                  <v-icon>chevron_right</v-icon>
                </v-btn>
              </v-layout>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card flat v-if="chooseEstate">
              <v-container style="text-align: center; padding-bottom: 0; margin-bottom: 0">
                <v-layout v-if="appLoading">
                  <v-flex>
                    <vue-loaders-ball-spin-fade-loader
                      v-if="appLoading"
                      :key="appLoading"
                      :color="$store.state.currentOrg.org.primaryColour"
                      scale="1"
                    ></vue-loaders-ball-spin-fade-loader>
                    <br />
                    <br />
                    <h2
                      :style="{
                        color: this.$store.state.currentOrg.org.secondaryColour,
                      }"
                      v-if="appLoading"
                    >
                      Fetching Available Networks...
                    </h2>
                    <br />
                    <br />
                  </v-flex>
                </v-layout>
                <v-layout v-if="!appLoading" class="justify-center">
                  <v-flex xs7>
                    <v-autocomplete
                      class="pointer"
                      style="cursor: pointer"
                      clearable
                      v-model="detail.address.estate"
                      :rules="[(v) => !!v || 'Estate is required']"
                      :items="estateList"
                      :loading="loading"
                      flat
                      v-on:change="setUnitList($event)"
                      :color="$store.state.currentOrg.org.primaryColour"
                      label="Pick your Estate/Area"
                      item-text="name"
                      item-value="id"
                    ></v-autocomplete>
                    <div v-show="this.detail.address.estate != null && networkData && !packagesLoading">
                      <v-autocomplete
                        v-if="networkData.isMDU"
                        class="pointer"
                        style="cursor: pointer"
                        clearable
                        v-model="locationTemplate"
                        :items="unitList"
                        :loading="appLoading"
                        flat
                        :color="$store.state.currentOrg.org.primaryColour"
                        label="Find My Address"
                        item-text="locationDescription"
                        item-value="id"
                        return-object
                        @change="setLocationInfoCard()"
                      ></v-autocomplete>
                      <v-text-field
                        v-else
                        v-model="searchLocation"
                        id="pac-input"
                        clearable
                        placeholder="Find My Address"
                      ></v-text-field>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>

              <!-- Address Details -->
              <v-container v-show="!appLoading" class="my-0 py-0">
                <v-layout class="my-0 py-0">
                  <v-flex>
                    <gmap-map
                      ref="mapRef"
                      :center="center"
                      :zoom="zoom"
                      :options="{
                        styles: myStyles,
                        streetViewControl: false,
                        disableDefaultUI: true,
                      }"
                      style="width: 100%; height: 50vh"
                      @click="getAddressData($event)"
                    >
                      <gmap-marker
                        v-if="locationMarker && mapLoaded"
                        :animation="1"
                        :position="locationMarker"
                        :key="key"
                        @click="setLocationInfoCard()"
                      ></gmap-marker>

                      <gmap-info-window
                        v-if="mapLoaded"
                        :options="infoOptions"
                        :position="locationMarker"
                        :opened="addressPromptWindow && $vuetify.breakpoint.smAndUp"
                        @closeclick="addressPromptWindow = false"
                      >
                        <v-card flat color="white" v-if="addressInformation">
                          <v-card-title>Oops!</v-card-title>
                          <v-card-text>
                            <h4 mx-1>
                              It looks like we haven't yet got your address details in our system. Are the below details
                              correct?
                            </h4>
                            <v-layout justify-center align-center wrap>
                              <v-flex xs5 mx-1>
                                <h4>Street Number:</h4>
                              </v-flex>
                              <v-flex xs5 mx-1
                                ><span>{{ addressInformation.streetNumber }}</span></v-flex
                              >
                              <v-flex xs5 mx-1>
                                <h4>Street:</h4>
                              </v-flex>
                              <v-flex xs5 mx-1
                                ><span>{{ addressInformation.streetName }}</span></v-flex
                              >
                              <v-flex xs5 mx-1>
                                <h4>Estate/Area:</h4>
                              </v-flex>
                              <v-flex xs5 mx-1
                                ><span>{{ networkData.name }}</span></v-flex
                              >
                            </v-layout>
                          </v-card-text>
                          <v-card-actions>
                            <v-layout justify-center align-center>
                              <v-btn
                                :color="$store.state.currentOrg.org.primaryColour"
                                class="white--text"
                                round
                                @click="
                                  max = 3;
                                  e1 = 3;
                                  chooseEstate = false;
                                  choosePackage = true;
                                  detail.internetPackageSelected == false;
                                "
                                >Choose a Package <v-icon color="white">chevron_right</v-icon></v-btn
                              >
                            </v-layout>
                          </v-card-actions>
                        </v-card>
                      </gmap-info-window>
                      <v-dialog v-if="$vuetify.breakpoint.xsOnly" v-model="addressPromptWindow">
                        <v-card flat color="white" v-if="addressInformation">
                          <v-card-title>Oops!</v-card-title>
                          <v-card-text>
                            <h4 mx-1>
                              It looks like we haven't yet got your address details in our system. Are the below details
                              correct?
                            </h4>
                            <v-layout justify-center align-center wrap>
                              <v-flex xs5 mx-1>
                                <h4>Street Number:</h4>
                              </v-flex>
                              <v-flex xs5 mx-1
                                ><span>{{ addressInformation.streetNumber }}</span></v-flex
                              >
                              <v-flex xs5 mx-1>
                                <h4>Street:</h4>
                              </v-flex>
                              <v-flex xs5 mx-1
                                ><span>{{ addressInformation.streetName }}</span></v-flex
                              >
                              <v-flex xs5 mx-1>
                                <h4>Estate/Area:</h4>
                              </v-flex>
                              <v-flex xs5 mx-1
                                ><span>{{ networkData.name }}</span></v-flex
                              >
                            </v-layout>
                          </v-card-text>
                          <v-card-actions>
                            <v-layout justify-center align-center>
                              <v-btn
                                :color="$store.state.currentOrg.org.primaryColour"
                                class="white--text"
                                round
                                @click="
                                  max = 3;
                                  e1 = 3;
                                  chooseEstate = false;
                                  choosePackage = true;
                                  detail.internetPackageSelected == false;
                                "
                                >Choose a Package <v-icon color="white">chevron_right</v-icon></v-btn
                              >
                            </v-layout>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <gmap-info-window
                        v-if="mapLoaded"
                        :options="infoOptions"
                        :position="locationMarker"
                        :opened="errorWindow && $vuetify.breakpoint.smAndUp"
                        @closeclick="errorWindow = false"
                      >
                        <v-card flat color="white">
                          <v-card-text class="grey--text">
                            <h4>
                              Oops! It looks like your address isn't in our coverage area.
                            </h4>
                          </v-card-text>
                        </v-card>
                      </gmap-info-window>
                      <v-dialog v-if="$vuetify.breakpoint.xsOnly" v-model="errorWindow">
                        <v-card flat color="white">
                          <v-card-text class="grey--text">
                            <h4>
                              Oops! It looks like your address isn't in our coverage area.
                            </h4>
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                      <gmap-info-window
                        v-if="mapLoaded"
                        :options="infoOptions"
                        :position="locationMarker"
                        :opened="locationInfoWindowOpen && $vuetify.breakpoint.smAndUp"
                        @closeclick="locationInfoWindowOpen = false"
                      >
                        <v-card :key="key" flat color="white" v-if="locationInfo">
                          <v-card-text>
                            <v-layout justify-center align-center wrap class="text-xs-left">
                              <v-flex v-if="!networkData.isMDU" xs3 mx-1>
                                <h3 class="grey--text">Address:</h3>
                              </v-flex>
                              <v-flex v-if="!networkData.isMDU" xs8 mx-1>
                                <h3 class="grey--text font-weight-light">
                                  {{ locationInfo.address }}
                                </h3>
                              </v-flex>
                              <v-flex xs3 mx-1 v-if="locationInfo.location" mt-1>
                                <h3 class="grey--text">Status:</h3>
                              </v-flex>
                              <v-flex xs8 mx-1 v-if="locationInfo.location" mt-1>
                                <h3 class="white--text">
                                  <v-layout justify-left align-center v-if="locationInfo.location.fibrePulled">
                                    <v-icon color="light-green">check_circle_outline</v-icon>
                                    <span class="grey--text font-weight-light">Fibre Ready</span>
                                  </v-layout>

                                  <v-layout justify-left align-center v-else>
                                    <v-icon color="orange">warning</v-icon>
                                    <span class="grey--text font-weight-light">Installation Required</span>
                                  </v-layout>

                                  <!-- <v-chip color="orange" class="white--text" v-else>Installation Required</v-chip> -->
                                </h3>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                          <v-card-actions>
                            <v-layout justify-center>
                              <v-btn
                                :color="$store.state.currentOrg.org.primaryColour"
                                class="white--text"
                                round
                                @click="
                                  max = 3;
                                  e1 = 3;
                                  chooseEstate = false;
                                  choosePackage = true;
                                  detail.internetPackageSelected == false;
                                "
                              >
                                Choose A Package
                                <v-icon color="white">chevron_right</v-icon>
                              </v-btn>
                            </v-layout>
                          </v-card-actions>
                        </v-card>
                        <v-card v-else flat color="white">
                          <v-card-text>
                            <v-layout justify-center wrap>
                              <v-flex xs10>
                                <v-progress-circular
                                  size="30"
                                  indeterminate
                                  :color="$store.state.currentOrg.org.primaryColour"
                                ></v-progress-circular>
                              </v-flex>
                              <v-flex xs8>
                                <h3 class="grey--text">
                                  Getting address information
                                </h3>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </gmap-info-window>
                      <v-dialog v-if="$vuetify.breakpoint.xsOnly" v-model="locationInfoWindowOpen">
                        <v-card :key="key" flat color="white" v-if="locationInfo">
                          <v-card-text>
                            <v-layout justify-center align-center wrap class="text-xs-left">
                              <v-flex v-if="!networkData.isMDU" xs4 mx-1>
                                <h3 class="grey--text">Address:</h3>
                              </v-flex>
                              <v-flex v-if="!networkData.isMDU" xs7 mx-1>
                                <h3 class="grey--text font-weight-light">
                                  {{ locationInfo.address }}
                                </h3>
                              </v-flex>
                              <v-flex xs3 mx-1 v-if="locationInfo.location" mt-1>
                                <h3 class="grey--text">Status:</h3>
                              </v-flex>
                              <v-flex xs8 mx-1 v-if="locationInfo.location" mt-1>
                                <h3 class="white--text">
                                  <v-layout justify-left align-center v-if="locationInfo.location.fibrePulled">
                                    <v-icon color="light-green">check_circle_outline</v-icon>
                                    <span class="grey--text font-weight-light">Fibre Ready</span>
                                  </v-layout>

                                  <v-layout justify-left align-center v-else>
                                    <v-icon color="orange">warning</v-icon>
                                    <span class="grey--text font-weight-light">Installation Required</span>
                                  </v-layout>

                                  <!-- <v-chip color="orange" class="white--text" v-else>Installation Required</v-chip> -->
                                </h3>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                          <v-card-actions>
                            <v-layout justify-center>
                              <v-btn
                                :color="$store.state.currentOrg.org.primaryColour"
                                class="white--text"
                                round
                                @click="
                                  max = 3;
                                  e1 = 3;
                                  chooseEstate = false;
                                  choosePackage = true;
                                  detail.internetPackageSelected == false;
                                "
                              >
                                Choose A Package
                                <v-icon color="white">chevron_right</v-icon>
                              </v-btn>
                            </v-layout>
                          </v-card-actions>
                        </v-card>
                        <v-card v-else flat color="white">
                          <v-card-text>
                            <v-layout justify-center wrap>
                              <v-flex xs10>
                                <v-progress-circular
                                  size="30"
                                  indeterminate
                                  :color="$store.state.currentOrg.org.primaryColour"
                                ></v-progress-circular>
                              </v-flex>
                              <v-flex xs8>
                                <h3 class="grey--text">
                                  Getting address information
                                </h3>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                      <gmap-info-window
                        v-if="mapLoaded"
                        :options="infoOptions"
                        :position="infoWindowPos"
                        :opened="infoWinOpen && $vuetify.breakpoint.smAndUp"
                        @closeclick="infoWinOpen = false"
                      >
                        <v-card flat color="white" v-if="polyInfo.fno" width="450px">
                          <v-toolbar flat :color="$store.state.currentOrg.org.primaryColour">
                            <h3 class="title white--text">
                              {{ polyInfo.name }}
                            </h3>
                          </v-toolbar>
                          <v-card-text>
                            <v-layout justify-center align-center wrap class="text-xs-left">
                              <v-flex xs5 v-if="polyInfo.fno">
                                <h3 class="grey--text">Network Operator:</h3>
                              </v-flex>
                              <v-flex xs7 v-if="polyInfo.fno">
                                <h3 class="grey--text font-weight-light" color="grey">
                                  {{ polyInfo.fno.name }}
                                </h3>
                              </v-flex>
                              <v-flex xs5 v-if="polyInfo.network && polyInfo.network.networkStatus">
                                <h3 class="grey--text">Network Status</h3>
                              </v-flex>
                              <v-flex xs7 v-if="polyInfo.network && polyInfo.network.networkStatus">
                                <v-chip
                                  v-if="polyInfo.network.networkStatus == 'Live'"
                                  small
                                  class="white--text"
                                  color="light-green"
                                  >Live</v-chip
                                >
                                <v-chip
                                  v-else-if="polyInfo.network.networkStatus == 'In Progress'"
                                  small
                                  class="white--text"
                                  color="blue"
                                  >In Progress</v-chip
                                >
                                <v-chip
                                  v-else-if="polyInfo.network.networkStatus == 'Planned'"
                                  small
                                  class="white--text"
                                  color="orange"
                                  >Planned</v-chip
                                >
                              </v-flex>
                              <v-flex xs5 v-if="polyInfo.units">
                                <h3 class="grey--text">No. of Units:</h3>
                              </v-flex>
                              <v-flex xs7 v-if="polyInfo.units">
                                <h3 class="grey--text font-weight-light" color="grey">
                                  {{ polyInfo.units }}
                                </h3>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </gmap-info-window>
                      <v-dialog v-if="$vuetify.breakpoint.xsOnly" v-model="infoWinOpen">
                        <v-card flat color="white" v-if="polyInfo.fno" width="450px">
                          <v-toolbar flat :color="$store.state.currentOrg.org.primaryColour">
                            <h3 class="title white--text">
                              {{ polyInfo.name }}
                            </h3>
                          </v-toolbar>
                          <v-card-text>
                            <v-layout justify-center align-center wrap class="text-xs-left">
                              <v-flex xs5 v-if="polyInfo.fno">
                                <h3 class="grey--text">Network Operator:</h3>
                              </v-flex>
                              <v-flex xs7 v-if="polyInfo.fno">
                                <h3 class="grey--text font-weight-light" color="grey">
                                  {{ polyInfo.fno.name }}
                                </h3>
                              </v-flex>
                              <v-flex xs5 v-if="polyInfo.network && polyInfo.network.networkStatus">
                                <h3 class="grey--text">Network Status</h3>
                              </v-flex>
                              <v-flex xs7 v-if="polyInfo.network && polyInfo.network.networkStatus">
                                <v-chip
                                  v-if="polyInfo.network.networkStatus == 'Live'"
                                  small
                                  class="white--text"
                                  color="light-green"
                                  >Live</v-chip
                                >
                                <v-chip
                                  v-else-if="polyInfo.network.networkStatus == 'In Progress'"
                                  small
                                  class="white--text"
                                  color="blue"
                                  >In Progress</v-chip
                                >
                                <v-chip
                                  v-else-if="polyInfo.network.networkStatus == 'Planned'"
                                  small
                                  class="white--text"
                                  color="orange"
                                  >Planned</v-chip
                                >
                              </v-flex>
                              <v-flex xs5 v-if="polyInfo.units">
                                <h3 class="grey--text">No. of Units:</h3>
                              </v-flex>
                              <v-flex xs7 v-if="polyInfo.units">
                                <h3 class="grey--text font-weight-light" color="grey">
                                  {{ polyInfo.units }}
                                </h3>
                              </v-flex>
                            </v-layout>
                          </v-card-text>
                        </v-card>
                      </v-dialog>
                    </gmap-map>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card flat v-if="choosePackage">
              <v-layout class="justify-left" v-if="installFee">
                <h2
                  class="align-left"
                  :style="{
                    color: this.$store.state.currentOrg.org.secondaryColour,
                  }"
                >
                  Installation Fees:
                </h2>
              </v-layout>
              <v-layout
                :style="{
                  color: this.$store.state.currentOrg.org.secondaryColour,
                }"
                v-if="installFee"
              >
                <v-flex>
                  <h3
                    v-if="installFee && flags.hasBusinessPacks && (residentialInstallFee > 0 || businessInstallFee > 0)"
                    class="align-left grey--text"
                  >
                    An installation fee of
                    <b>{{ residentialInstallFee | currency }}</b> applies for Residential Packages and
                    <b>{{ businessInstallFee | currency }}</b> for Business Packages.
                  </h3>
                  <h3
                    v-else-if="installFee && !flags.hasBusinessPacks && residentialInstallFee > 0"
                    class="text-xs-left grey--text"
                  >
                    An installation fee of
                    <b>{{ residentialInstallFee | currency }}</b> may apply upon completion of the order prior to
                    installation.
                  </h3>
                </v-flex>
              </v-layout>
              <v-layout
                v-if="
                  (fnoPackagesResidentialPromoSpeeds.length > 0 || fnoPackagesBusinessPromoSpeeds.length > 0) &&
                    installFee
                "
              >
                <v-flex>
                  <h2 class="red--text text-xs-left subheading">
                    <b>PROMO OFFER!</b>
                  </h2>
                </v-flex>
              </v-layout>
              <v-layout
                v-if="
                  (fnoPackagesResidentialPromoSpeeds.length > 0 || fnoPackagesBusinessPromoSpeeds.length > 0) &&
                    installFee
                "
              >
                <v-flex>
                  <h3 class="text-xs-left subheading">
                    The Fibre Installation Fee will be waived if you sign up for any of the following:
                  </h3>
                  <h3
                    :style="{
                      color: this.$store.state.currentOrg.org.secondaryColour,
                    }"
                    v-if="fnoPackagesResidentialPromoSpeeds.length > 0"
                    class="text-xs-left subheading"
                  >
                    Residential Packages:
                  </h3>
                </v-flex>
              </v-layout>
              <v-layout
                :style="{
                  color: this.$store.state.currentOrg.org.secondaryColour,
                }"
                v-if="fnoPackagesResidentialPromoSpeeds.length > 0 && installFee"
              >
                <v-flex v-for="item in fnoPackagesResidentialPromoSpeeds" :key="item.id">
                  <b>{{ item }} Mbps</b>
                </v-flex>
              </v-layout>
              <v-layout
                :style="{
                  color: this.$store.state.currentOrg.org.secondaryColour,
                }"
                v-if="fnoPackagesBusinessPromoSpeeds.length > 0 && installFee"
              >
                <v-flex v-for="item in fnoPackagesBusinessPromoSpeeds" :key="item.id">
                  <b>{{ item }} Mbps</b>
                </v-flex>
              </v-layout>

              <v-layout wrap>
                <v-text-field
                  v-model="searchPackages"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  max-width="50px"
                  clearable
                ></v-text-field>
              </v-layout>
              <v-data-table
                v-model="selected"
                :headers="packageHeaders"
                :items="packagesList"
                :pagination.sync="pagination"
                :search="searchPackages"
                :rows-per-page-items="[10, 25, 50, 100]"
                item-key="id"
              >
                <template v-slot:items="props">
                  <tr
                    :active="props.selected"
                    @click="
                      props.selected = !props.selected;
                      onSelection();
                    "
                  >
                    <td>
                      <v-checkbox
                        :input-value="props.selected"
                        primary
                        @click="selected = []"
                        hide-details
                      ></v-checkbox>
                    </td>
                    <td class="text-xs-center">{{ props.item.name }}</td>
                    <td class="text-xs-center">{{ props.item.term }}</td>
                    <td class="text-xs-center">
                      {{ props.item.onceOffPriceVatInc | currency }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.recurringPriceVatInc | currency }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.packagesFno.speedProfile.downloadMbps
                      }}<v-icon size="medium">arrow_downward</v-icon> {{ props.item.packagesFno.speedProfile.uploadMbps
                      }}<v-icon size="medium">arrow_upward</v-icon> Mbps
                    </td>
                    <td class="text-xs-center">
                      <v-chip color="light-green" class="white--text" v-if="props.item.isActive">Visible</v-chip>
                      <v-chip color="red" class="white--text" v-else>Not Visible</v-chip>
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <v-layout>
                <v-btn
                  class="justify-left white--text"
                  medium
                  round
                  @click="
                    e1 = 2;
                    choosePackage = false;
                    chooseEstate = true;
                  "
                  :color="$store.state.currentOrg.org.primaryColour"
                >
                  <v-icon>chevron_left</v-icon>PREVIOUS
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn
                  class="justify-end white--text"
                  medium
                  v-if="this.max == 3 && this.validPackage === true"
                  round
                  @click="
                    max = 4;
                    e1 = 4;
                    choosePackage = false;
                    chooseContact = true;
                  "
                  :color="$store.state.currentOrg.org.primaryColour"
                >
                  NEXT
                  <v-icon>chevron_right</v-icon>
                </v-btn>
                <v-btn
                  class="white--text"
                  medium
                  v-else-if="this.max != 3 && this.validPackage === true"
                  round
                  @click="
                    e1 = 4;
                    choosePackage = false;
                    chooseContact = true;
                  "
                  :color="$store.state.currentOrg.org.primaryColour"
                >
                  NEXT
                  <v-icon>chevron_right</v-icon>
                </v-btn>
                <v-btn
                  class="white--text"
                  v-else
                  medium
                  round
                  disabled
                  :color="$store.state.currentOrg.org.primaryColour"
                >
                  NEXT
                  <v-icon>chevron_right</v-icon>
                </v-btn>
              </v-layout>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="4">
            <v-card flat v-if="chooseContact">
              <h2
                class="justify-center input-flex-min-space"
                :style="{
                  color: this.$store.state.currentOrg.org.primaryColour,
                }"
              >
                Primary Contact Info
              </h2>
              <v-layout class="justify-center input-flex-min-space">
                <v-flex xs6>
                  <v-select
                    v-model="detail.primaryContact.title"
                    :items="titles"
                    :rules="titleRules"
                    label="Title*"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout class="justify-center input-flex-min-space">
                <v-flex xs6>
                  <v-text-field
                    v-model="detail.primaryContact.firstName"
                    label="First Name* "
                    :rules="nameRules"
                    class="input-flex-min-space"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout class="justify-center input-flex-min-space">
                <v-flex xs6>
                  <v-text-field
                    v-model="detail.primaryContact.lastName"
                    label="Last Name*"
                    :rules="surnameRules"
                    class="input-flex-min-space"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout class="justify-center input-flex-min-space">
                <v-flex xs6>
                  <v-text-field
                    class="input-flex-min-space"
                    v-model="detail.primaryContact.contactNumber"
                    :rules="contactNumberRules"
                    label="Contact Number*"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout class="justify-center input-flex-min-space">
                <v-flex xs6>
                  <v-text-field
                    class="input-flex-min-space"
                    v-model="detail.primaryContact.emailAddress"
                    :rules="emailRules"
                    label="Email Address*"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout class="justify-center input-flex-min-space">
                <v-flex xs6>
                  <v-text-field
                    class="input-flex-min-space"
                    v-model="detail.primaryContact.idNumber"
                    :rules="idNumberRules"
                    label="ID Number*"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-flex v-if="this.detail.showSecondaryContact == true">
                <h2
                  :style="{
                    color: this.$store.state.currentOrg.org.primaryColour,
                  }"
                >
                  Secondary Contact Info
                </h2>
                <v-layout class="justify-center">
                  <v-flex xs6>
                    <v-select
                      class="input-flex-min-space"
                      v-model="detail.secondaryContact.title"
                      :items="titles"
                      :rules="titleRules"
                      label="Title* "
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6>
                    <v-text-field
                      class="input-flex-min-space"
                      v-model="detail.secondaryContact.firstName"
                      :rules="nameRules"
                      label="First Name* "
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6>
                    <v-text-field
                      class="input-flex-min-space"
                      v-model="detail.secondaryContact.lastName"
                      :rules="surnameRules"
                      label="Last Name*"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6>
                    <v-text-field
                      class="input-flex-min-space"
                      v-model="detail.secondaryContact.contactNumber"
                      :rules="contactNumberRules"
                      label="Contact Number*"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6>
                    <v-text-field
                      class="input-flex-min-space"
                      v-model="detail.secondaryContact.emailAddress"
                      :rules="emailRules"
                      label="Email Address*"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6>
                    <v-text-field
                      class="input-flex-min-space"
                      v-model="detail.secondaryContact.idNumber"
                      :rules="idNumberRules"
                      label="ID Number*"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6>
                    <v-text-field
                      class="input-flex-min-space"
                      v-model="detail.secondaryContact.relationToPrimary"
                      label="Relation to primary contact"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6>
                    <v-container v-if="this.detail.showSecondaryContact == true">
                      <v-btn
                        round
                        class="white--text"
                        :color="$store.state.currentOrg.org.primaryColour"
                        @click="resetSec()"
                      >
                        <v-icon round dark flat>remove</v-icon>Secondary Contact
                      </v-btn>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex v-if="this.detail.addBillingContact == true">
                <h2
                  :style="{
                    color: this.$store.state.currentOrg.org.primaryColour,
                  }"
                >
                  Billing Contact Info
                </h2>
                <v-layout class="justify-center">
                  <v-flex xs6>
                    <v-select
                      class="input-flex-min-space"
                      v-model="detail.billingContact.title"
                      :items="titles"
                      :rules="titleRules"
                      label="Title*"
                    ></v-select>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6>
                    <v-text-field
                      class="input-flex-min-space"
                      v-model="detail.billingContact.firstName"
                      :rules="nameRules"
                      label="Billing Contact First Name* "
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6>
                    <v-text-field
                      class="input-flex-min-space"
                      v-model="detail.billingContact.lastName"
                      :rules="surnameRules"
                      label="Billing Contact Last Name*"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6>
                    <v-text-field
                      class="input-flex-min-space"
                      v-model="detail.billingContact.contactNumber"
                      :rules="contactNumberRules"
                      label="Billing Contact Contact Number*"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6>
                    <v-text-field
                      class="input-flex-min-space"
                      v-model="detail.billingContact.emailAddress"
                      :rules="emailRules"
                      label="Billing Contact Email Address*"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6>
                    <v-text-field
                      class="input-flex-min-space"
                      :rules="idNumberRules"
                      v-model="detail.billingContact.idNumber"
                      label="Billing Contact ID Number*"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6>
                    <v-checkbox
                      class="input-flex-min-space"
                      v-model="detail.billingAddressSame"
                      label=" My Billing Address is the same as my Residential Address"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6 v-if="!detail.billingAddressSame">
                    <v-text-field
                      class="input-flex-min-space"
                      v-model="detail.billingContact.physicalAddressLine1"
                      label="Physical address line 1*"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6 v-if="!detail.billingAddressSame">
                    <v-text-field
                      class="input-flex-min-space"
                      v-model="detail.billingContact.physicalAddressLine2"
                      label="Physical address line 2*"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6 v-if="!detail.billingAddressSame">
                    <v-text-field
                      class="input-flex-min-space"
                      v-model="detail.billingContact.physicalAddressLine3"
                      label="Physical address line 3*"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6>
                    <v-checkbox class="input-flex-min-space" v-model="detail.isBusiness">
                      <template v-slot:label>
                        <v-form class="subheading">Billing needs to be sent to a company</v-form>
                      </template>
                    </v-checkbox>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6 v-if="detail.isBusiness">
                    <v-text-field
                      class="input-flex-min-space"
                      v-model="detail.organisationName"
                      label="Company Name"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6 v-if="detail.isBusiness">
                    <v-text-field
                      class="input-flex-min-space"
                      v-model="detail.billingContact.vatNumber"
                      label="VAT Number"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout class="justify-center">
                  <v-flex xs6>
                    <v-container v-if="this.detail.addBillingContact == true">
                      <v-btn
                        class="white--text"
                        round
                        :color="$store.state.currentOrg.org.primaryColour"
                        @click="resetBill()"
                      >
                        <v-icon round dark flat>remove</v-icon>Billing Contact
                      </v-btn>
                    </v-container>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex v-if="this.detail.showSecondaryContact == false">
                <v-btn
                  medium
                  class="white--text"
                  round
                  :color="$store.state.currentOrg.org.primaryColour"
                  @click="detail.showSecondaryContact = true"
                >
                  <v-icon round dark flat>add</v-icon>Secondary Contact
                </v-btn>
              </v-flex>
              <v-flex v-if="this.detail.addBillingContact == false">
                <v-btn
                  class="white--text"
                  round
                  :color="$store.state.currentOrg.org.primaryColour"
                  @click="detail.addBillingContact = true"
                >
                  <v-icon round dark flat>add</v-icon>Billing Contact
                </v-btn>
              </v-flex>
              <v-layout>
                <v-btn
                  class="justify-left white--text"
                  medium
                  round
                  @click="
                    e1 = 3;
                    chooseContact = false;
                    choosePackage = true;
                  "
                  :color="$store.state.currentOrg.org.primaryColour"
                >
                  <v-icon>chevron_left</v-icon>PREVIOUS
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn
                  class="justify-center white--text"
                  v-if="validatePrim() == true && validateSec() == true && validateBill() == true && this.max == 4"
                  medium
                  round
                  @click="
                    max = 5;
                    e1 = 5;
                    chooseContact = false;
                    chooseAdditional = true;
                  "
                  :color="$store.state.currentOrg.org.primaryColour"
                >
                  NEXT
                  <v-icon>chevron_right</v-icon>
                </v-btn>
                <v-btn
                  class="white--text"
                  v-else-if="validatePrim() == true && validateSec() == true && validateBill() == true && this.max != 4"
                  medium
                  round
                  @click="
                    e1 = 5;
                    chooseContact = false;
                    chooseAdditional = true;
                  "
                  :color="$store.state.currentOrg.org.primaryColour"
                >
                  NEXT
                  <v-icon>chevron_right</v-icon>
                </v-btn>
                <v-btn
                  class="white--text"
                  v-else
                  medium
                  round
                  disabled
                  :color="$store.state.currentOrg.org.primaryColour"
                >
                  NEXT
                  <v-icon>chevron_right</v-icon>
                </v-btn>
              </v-layout>
            </v-card>
          </v-stepper-content>
          <v-stepper-content step="5">
            <!-- Additional-->
            <v-card flat v-if="chooseAdditional">
              <v-container style="text-align: center">
                <v-layout justify-center>
                  <v-flex sm8 md8 class="text-center">
                    <v-textarea
                      outlined
                      placeholder="Any Additional notes/requirements"
                      v-model="detail.notes"
                    ></v-textarea>
                  </v-flex>
                </v-layout>
                <v-layout justify-center>
                  <v-flex sm4 md4 class="text-center">
                    <h4 style="text-align: left; color: red" class="subheading">
                      PROMO Code:
                    </h4>
                  </v-flex>
                  <v-flex sm4 md4 class="text-center">
                    <v-text-field class="input-flex-min-space" v-model="detail.promoCode" placeholder="Promotion Code">
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-layout>
                <v-btn
                  class="justify-left white--text"
                  medium
                  round
                  @click="
                    e1 = 4;
                    chooseAdditional = false;
                    chooseContact = true;
                  "
                  :color="$store.state.currentOrg.org.primaryColour"
                >
                  <v-icon>chevron_left</v-icon>PREVIOUS
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn
                  class="justify-center white--text"
                  medium
                  round
                  @click="
                    max = 6;
                    e1 = 6;
                    chooseAdditional = false;
                    chooseDate = true;
                  "
                  :color="$store.state.currentOrg.org.primaryColour"
                >
                  NEXT
                  <v-icon>chevron_right</v-icon>
                </v-btn>
              </v-layout>
            </v-card>
          </v-stepper-content>
          <v-stepper-content step="6">
            <!-- Activation Date -->
            <v-card flat v-if="chooseDate">
              <v-container style="text-align: center">
                <v-layout>
                  <v-flex>
                    <h3 class="font-weight-light pt-0 mt-0 mb-2">
                      We will do our best to accommodate you, however this date is subject to availability.
                    </h3>
                  </v-flex>
                </v-layout>
                <v-layout>
                  <v-flex>
                    <v-date-picker
                      no-title
                      scrollable
                      v-model="detail.activationDate"
                      :min="minActivationDate"
                      :allowed-dates="allowedDates"
                    ></v-date-picker>
                  </v-flex>
                </v-layout>
              </v-container>

              <v-layout>
                <v-btn
                  class="justify-left white--text"
                  medium
                  round
                  @click="
                    e1 = 5;
                    chooseDate = false;
                    chooseAdditional = true;
                  "
                  :color="$store.state.currentOrg.org.primaryColour"
                >
                  <v-icon>chevron_left</v-icon>PREVIOUS
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn
                  class="justify-center white--text"
                  v-if="this.detail.activationDate != '' && this.max == 6"
                  medium
                  round
                  @click="
                    max = 7;
                    e1 = 7;
                    submit();
                  "
                  :color="$store.state.currentOrg.org.primaryColour"
                >
                  SUBMIT
                </v-btn>

                <v-btn
                  class="white--text"
                  v-else
                  medium
                  round
                  disabled
                  :color="$store.state.currentOrg.org.primaryColour"
                >
                  SUBMIT
                </v-btn>
              </v-layout>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-dialog>
  </div>
</template>
<script>
import Api from "@/services/Api.js";
import Loading from "vue-loading-overlay";
import GeoJsonGeometriesLookup from "geojson-geometries-lookup";
import { gmapApi } from "vue2-google-maps";
import "vue-loading-overlay/dist/vue-loading.css";
var disabledDates = [
  ,
  "2019-12-23",
  "2019-12-24",
  "2019-12-25",
  "2019-12-26",
  "2019-12-27",
  "2019-12-28",
  "2019-12-29",
  "2019-12-30",
  "2019-12-31",
  "2020-01-01",
  "2020-01-02",
  "2020-01-03",
  "2020-01-04",
  "2020-01-05",
  "2020-01-06",
  "2020-01-07",
  "2020-01-08",
  "2020-01-09",
  "2020-01-10",
];

export default {
  org: [],
  components: {
    Loading,
  },
  data() {
    return {
      operatorChosen: false,
      networkOperators: [],
      searchPackages: "",
      selected: [],
      packagesList: [],
      addOrderButton: false,
      loading: false,
      center: { lat: 18.427059, lng: -33.919473 },
      locationMarker: {},
      errorWindow: false,
      locationInfo: {},
      networkData: {},
      locationInfoWindowOpen: false,
      geocoder: null,
      geoData: {},
      glookup: null,
      markers: [],
      places: [],
      polyInfo: {},
      map: undefined,
      mapLoaded: false,
      markerData: {},
      currentPlace: null,
      item: {},
      key: 0,
      myCityData: null,
      networkPolygons: [],
      itemModal: false,
      infoContent: "",
      myStyles: [
        {
          elementType: "geometry",
          stylers: [
            {
              color: "#f5f5f5",
            },
          ],
        },
        {
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#616161",
            },
          ],
        },
        {
          elementType: "labels.text.stroke",
          stylers: [
            {
              color: "#f5f5f5",
            },
          ],
        },
        {
          featureType: "administrative",
          elementType: "geometry",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.land_parcel",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#bdbdbd",
            },
          ],
        },
        {
          featureType: "poi",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [
            {
              color: "#eeeeee",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#757575",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [
            {
              color: "#e5e5e5",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [
            {
              color: "#ffffff",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#757575",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [
            {
              color: "#dadada",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#616161",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e",
            },
          ],
        },
        {
          featureType: "transit",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "transit.line",
          elementType: "geometry",
          stylers: [
            {
              color: "#e5e5e5",
            },
          ],
        },
        {
          featureType: "transit.station",
          elementType: "geometry",
          stylers: [
            {
              color: "#eeeeee",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              color: "#c9c9c9",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e",
            },
          ],
        },
      ],
      addressPromptWindow: false,
      addressInformation: {},
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      searchLocation: "",
      zoom: 14,
      validPackage: false,
      editIfValidOperator: false,
      editIfValidEstate: false,
      editIfValidPackage: false,
      editIfValidDate: false,
      editIfValidContact: false,
      editIfValidAdditional: false,
      altlabel: true,
      about: null,
      val: false,
      e1: 1,
      chooseOperator: true,
      chooseEstate: false,
      choosePackage: false,
      chooseAddress: false,
      chooseContact: false,
      chooseAdditional: false,
      key: 0,
      packagesIsps: [],
      customerList: [],
      installFee: false,
      acceptInfoSharing: false,
      businessInstallFee: null,
      residentialInstallFee: null,
      valid: false,
      allPackages: [],
      providerList: [],
      fnoPackagesResidentialPromoSpeeds: [],
      fnoPackagesBusinessPromoSpeeds: [],
      fnoPackagesPromoIdList: [],
      fnoPromoPackages: [],
      appLoading: false,
      loadingText: null,
      packagesLoading: false,
      mapKey: 0,
      dateRules: [(v) => !!v || "Date is required"],
      nameRules: [(v) => !!v || "Name is required"],
      surnameRules: [(v) => !!v || "Last Name is required"],
      contactNumberRules: [
        (v) => !!v || "Contact Number is required",
        (v) => (v && v.length > 9) || "Contact Number should be 10 digits",
      ],
      idNumberRules: [
        (v) => !!v || "ID Number is required",
        (v) => (v && v.length > 8) || "Please Enter a Valid ID Number",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "E-mail must be valid",
      ],
      titleRules: [(v) => !!v || "Title is required"],
      packageHeaders: [
        {
          text: "Action",
          align: "center",
        },
        {
          text: "Name",
          align: "center",
          value: "name",
        },
        {
          text: "Term",
          align: "center",
          value: "term",
        },
        {
          text: "Once Off Price Vat Inc",
          align: "center",
          value: "onceOffPriceVatInc",
        },
        {
          text: "Recurring Price Vat Inc",
          align: "center",
          value: "recurringPriceVatInc",
        },
        {
          text: "Download/ Upload Speed",
          align: "center",
          value: "packagesFno.speedProfile.downloadMbps/packagesFno.speedProfile.uploadMbps",
        },
        {
          text: "Status",
          align: "center",
          value: "isActive",
        },
      ],
      locationTemplate: null,
      detail: {
        networkOperator: {},
        primaryContact: {},
        secondaryContact: {},
        address: {
          unitNumber: null,
          fullUnitDetails: null,
        },
        billingAddressSame: true,
        isPropertyOwner: true,
        isPropertyTenant: false,
        internetPackageSelected: false,
        includeTVOverFibrePackage: false,
        tenantContact: {},
        ownerContact: {},
        billingContact: {},
        activationDate: "",
        selectedInternetPackage: null,
        selectedNetwork: {},
        showSecondaryContact: false,
        addBillingContact: false,
        signature: null,
        isBusiness: false,
        organisationName: "",
      },
      flags: {
        addPackageSelected: false,
        hasBusinessPacks: false,
      },
      titles: ["Mr", "Mrs", "Miss", "Dr", "Prof", "Sir", "Madam", "Other"],
      estateList: [],
      unitList: [],
      errorMessage: "",
      showError: false,
      selectUnitModal: false,
      loading: false,
      search: "",
      minActivationDate: this.formatDate(this.addDays(new Date(), 4)),
      pagination: { totalItems: 0 },
      editIfValid: false,
      max: 1,
      estateArr: ["1"],
    };
  },
  watch: {
    chooseEstate(value) {
      if (value == true) {
        setTimeout(() => {
          // this.center = this.center
          // this.mapKey+=1
          this.plotMap();
        }, 3000);
      }
    },
    locationTemplate(value) {
      if (typeof value !== "undefined" && value !== null) {
        this.selectUnit(value);
      }
    },
    "detail.selectedInternetPackage": {
      immediate: true,
      handler(value) {
        if (value) {
          this.validPackage = true;
        } else {
          this.validPackage = false;
        }
      },
    },
    "detail.address.estate": {
      immediate: true,
      handler(value) {
        this.estateArr.push(value);
        if (this.estateArr[0] != value) {
          this.max = 2;
        }
        this.estateArr.shift();
      },
    },
  },
  computed: {
    google: gmapApi,
  },

  created() {
    this.initialize();
  },
  mounted: function() {
    // this.map = this.$refs.mapRef.$mapObject;
    // this.$refs.mapRef.$mapCreated.then(() => {
    //   this.mapLoaded = true;
    // });
  },
  methods: {
    onSelection() {
      this.detail.selectedInternetPackage = this.selected[0];
    },
    validateEmail() {
      if (
        this.detail.primaryContact.emailAddress != null &&
        this.detail.primaryContact.emailAddress != "" &&
        this.validEmail(this.detail.primaryContact.emailAddress)
      ) {
        return true;
      } else {
        return false;
      }
    },
    stepOperator() {
      (this.chooseOperator = true), (this.e1 = 1);
      if (this.max >= 1) {
        this.editIfValidOperator = true;
      } else {
        this.editIfValidOperator = false;
      }
    },
    stepEstate() {
      if (this.max < 2) {
        this.max = 2;
      }
      (this.chooseEstate = true), (this.e1 = 2);
      if (this.max >= 2) {
        this.editIfValidEstate = true;
      } else {
        this.editIfValidEstate = false;
      }
    },
    stepPackage() {
      if (this.max < 3) {
        this.max = 3;
      }
      (this.choosePackage = true), (this.e1 = 3);
      if (this.max >= 3) {
        this.editIfValidPackage = true;
      } else {
        this.editIfValidPackage = false;
      }
    },
    stepContact() {
      if (this.max < 4) {
        this.max = 4;
      }
      (this.chooseContact = true), (this.e1 = 4);
      if (this.max >= 4) {
        this.editIfValidContact = true;
      } else {
        this.editIfValidContact = false;
      }
    },
    stepAdditional() {
      if (this.max < 5) {
        this.max = 5;
      }
      (this.chooseAdditional = true), (this.e1 = 5);
      if (this.max >= 5) {
        this.editIfValidAdditional = true;
      } else {
        this.editIfValidAdditional = false;
      }
    },
    stepDate() {
      if (this.max < 6) {
        this.max = 6;
      }

      (this.chooseDate = true), (this.e1 = 6);
      if (this.max >= 6) {
        if (this.detail.activationDate != null) {
          this.editIfValidDate = true;
        } else {
          this.editIfValidDate = false;
        }
      } else {
        this.editIfValidDate = false;
      }
    },

    clearDetail() {
      (this.detail.primaryContact = {}),
        (this.detail.secondaryContact = {}),
        (this.detail.address.unitNumber = null),
        (this.detail.address.fullUnitDetails = null),
        (this.detail.address.estate = null),
        (this.locationTemplate = null),
        (this.detail.billingAddressSame = true),
        (this.detail.isPropertyOwner = true),
        (this.detail.isPropertyTenant = false),
        (this.detail.internetPackageSelected = false),
        (this.detail.includeTVOverFibrePackage = false),
        (this.detail.tenantContact = {}),
        (this.detail.ownerContact = {}),
        (this.detail.billingContact = {}),
        (this.detail.activationDate = ""),
        (this.detail.selectedInternetPackage = null),
        (this.detail.selectedNetwork = {}),
        (this.detail.showSecondaryContact = false),
        (this.detail.addBillingContact = false),
        (this.detail.signature = null),
        (this.detail.isBusiness = false),
        (this.detail.organisationName = ""),
        (this.acceptInfoSharing = false),
        (this.ISPTermsSigned = false),
        (this.termsSigned = false),
        (this.signature = false),
        (this.max = 1);
    },
    resetSec() {
      this.detail.showSecondaryContact = false;
      this.detail.secondaryContact = {};
    },
    resetBill() {
      this.detail.addBillingContact = false;
      this.detail.billingContact = {};
    },
    validatePrim() {
      if (
        this.detail.primaryContact.title != null &&
        this.detail.primaryContact.title != "" &&
        this.detail.primaryContact.firstName != null &&
        this.detail.primaryContact.firstName != "" &&
        this.detail.primaryContact.lastName != null &&
        this.detail.primaryContact.lastName != "" &&
        this.detail.primaryContact.contactNumber != null &&
        this.detail.primaryContact.contactNumber != "" &&
        this.detail.primaryContact.contactNumber.length >= 10 &&
        this.detail.primaryContact.emailAddress != null &&
        this.detail.primaryContact.emailAddress != "" &&
        this.validEmail(this.detail.primaryContact.emailAddress) &&
        this.detail.primaryContact.idNumber != null &&
        this.detail.primaryContact.idNumber != "" &&
        this.detail.primaryContact.idNumber.length >= 9
      ) {
        return true;
      }
    },
    validateSec() {
      if (this.detail.showSecondaryContact == true) {
        if (
          this.detail.secondaryContact.title != null &&
          this.detail.secondaryContact.title != "" &&
          this.detail.secondaryContact.firstName != null &&
          this.detail.secondaryContact.firstName != "" &&
          this.detail.secondaryContact.lastName != null &&
          this.detail.secondaryContact.lastName != "" &&
          this.detail.secondaryContact.contactNumber != null &&
          this.detail.secondaryContact.contactNumber != "" &&
          this.detail.secondaryContact.contactNumber.length >= 10 &&
          this.detail.secondaryContact.emailAddress != null &&
          this.detail.secondaryContact.emailAddress != "" &&
          this.validEmail(this.detail.secondaryContact.emailAddress) &&
          this.detail.secondaryContact.idNumber != null &&
          this.detail.secondaryContact.idNumber != "" &&
          this.detail.secondaryContact.idNumber.length >= 9
        ) {
          return true;
        }
      } else if (this.detail.showSecondaryContact == false) {
        return true;
      }
    },
    validateBill() {
      if (this.detail.addBillingContact == true) {
        if (
          this.detail.billingContact.title != null &&
          this.detail.billingContact.title != "" &&
          this.detail.billingContact.firstName != null &&
          this.detail.billingContact.firstName != "" &&
          this.detail.billingContact.lastName != null &&
          this.detail.billingContact.lastName != "" &&
          this.detail.billingContact.contactNumber != null &&
          this.detail.billingContact.contactNumber != "" &&
          this.detail.billingContact.contactNumber.length >= 10 &&
          this.detail.billingContact.emailAddress != null &&
          this.detail.billingContact.emailAddress != "" &&
          this.validEmail(this.detail.billingContact.emailAddress) &&
          this.detail.billingContact.idNumber != null &&
          this.detail.billingContact.idNumber != "" &&
          this.detail.billingContact.idNumber.length >= 9
        ) {
          if (
            !this.detail.billingAddressSame &&
            this.detail.billingContact.physicalAddressLine1 != null &&
            this.detail.billingContact.physicalAddressLine1 != "" &&
            this.detail.billingContact.physicalAddressLine2 != null &&
            this.detail.billingContact.physicalAddressLine2 != "" &&
            this.detail.billingContact.physicalAddressLine3 != null &&
            this.detail.billingContact.physicalAddressLine3 != ""
          ) {
            return true;
          } else if (this.detail.billingAddressSame) {
            return true;
          } else {
            return false;
          }
        }
      } else if (this.detail.addBillingContact == false) {
        return true;
      }
    },
    getAddressData: async function(addressData, placeResultData, id) {
      this.geocoder = new google.maps.Geocoder();
      var latlng = new google.maps.LatLng(addressData.latLng.lat(), addressData.latLng.lng());
      this.infoWindowPos = {
        lat: addressData.latLng.lat(),
        lng: addressData.latLng.lng(),
      };
      let resultData = null;
      await this.geocoder.geocode(
        {
          latLng: latlng,
        },
        async function(results, status) {
          if (status === google.maps.GeocoderStatus.OK) {
            if (results[1]) {
              resultData = results[1];
            } else {
              alert("No results found");
            }
          } else {
            alert("Geocoder failed due to: " + status);
          }
        }
      );
    },
    plotMap() {
      this.$refs.mapRef.$mapPromise.then((map) => {
        // this.initMapAutocomplete();
        this.map = map;
        this.mapLoaded = true;
        this.map.data.addGeoJson(this.geoData);
        this.map.data.setStyle((feature) => {
          return {
            fillColor: this.detail.networkOperator.primaryColour,
            fillOpacity: 0.3,
            strokeWeight: 2,
            strokeColor: this.detail.networkOperator.primaryColour,
          };
        });
        this.map.data.addListener("click", (event) => {
          this.polyInfo = {
            type: "Network",
            name: event.feature.j.name,
            units: event.feature.j.units,
            fno: event.feature.j.fno,
            network: event.feature.j.network,
          };
          this.setUnitList(this.polyInfo.network.id);
          this.openWindow(event);
          let testPoly = new google.maps.Polygon({
            paths: event.feature
              .getGeometry()
              .getAt(0)
              .getArray(),
          });
          if (google.maps.geometry.poly.containsLocation(event.latLng, testPoly)) {
            // This works now, still have to loop through the arrays for the multipolygons
          }
        });
      });
    },
    openWindow(data) {
      this.infoWindowPos = {
        lat: data.latLng.lat(),
        lng: data.latLng.lng(),
      };
      this.infoWinOpen = true;
    },
    // geolocate: function () {
    //       // this.center = {
    //       //   lat: -33.918861,
    //       //   lng: 18.423300
    //       // }
    // },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    isWithinPoly(event) {
      var isWithinPolygon = google.maps.geometry.poly.containsLocation(event.latLng, this);
    },
    async initMapAutocomplete(network) {
      const input = document.getElementById("pac-input");
      const autocomplete = new google.maps.places.Autocomplete(input, {
        types: ["address"],
      });
      autocomplete.setComponentRestrictions({
        country: ["za"],
      });
      var circle = new google.maps.Circle({
        center: {
          lat: parseFloat(network.geoLatitude),
          lng: parseFloat(network.geoLongitude),
        },
        radius: 500,
      });
      autocomplete.setBounds(circle.getBounds());
      autocomplete.setOptions({ strictBounds: true });

      google.maps.event.addListener(autocomplete, "place_changed", async () => {
        this.locationInfoWindowOpen = false;
        this.errorWindow = false;
        this.addressPromptWindow = false;
        const place = autocomplete.getPlace();
        const location = place.geometry.location;
        const point = {
          type: "Point",
          coordinates: [location.lng(), location.lat()],
        };
        let testPoly = this.glookup.getContainers(point);
        let curPlace = autocomplete.getPlace();
        this.center = curPlace.geometry.location;
        this.locationMarker = this.center;
        if (testPoly.features.length > 0) {
          let streetNumber = curPlace.address_components.find((x) => x.types.includes("street_number"));
          let streetName = curPlace.address_components.find((x) => x.types.includes("route"));
          if (!streetName || !streetNumber) {
            let predictedStreet = autocomplete.gm_accessors_.place.qe.formattedPrediction.split(", ");
            let number = predictedStreet[0].substr(0, predictedStreet[0].indexOf(" "));
            let street = predictedStreet[0].substr(predictedStreet[0].indexOf(" ") + 1);
            this.locationTemplate = this.unitList.find((x) => x.unitNo == number && x.complexStreetName == street);
            this.searchLocation = autocomplete.gm_accessors_.place.qe.formattedPrediction;
            console.log("searchLocation", this.searchLocation);
            if (this.locationTemplate) {
              this.locationInfo = {
                address: curPlace.formatted_address,
                fno: this.detail.networkOperator,
                location: {
                  fibrePulled: this.locationTemplate.fibrePulled,
                  equipmentInstalled: this.locationTemplate.equipmentInstalled,
                },
              };
              this.locationInfoWindowOpen = true;
            } else {
              this.addressInformation = {
                streetNumber: number,
                streetName: street,
              };
              this.addressPromptWindow = true;
            }
          } else {
            this.locationTemplate = this.unitList.find(
              (x) => x.unitNo == streetNumber.short_name && x.complexStreetName == streetName.short_name
            );
            this.searchLocation = curPlace.formatted_address;

            if (this.locationTemplate) {
              this.locationInfo = {
                address: curPlace.formatted_address,
                fno: this.detail.networkOperator,
                location: {
                  fibrePulled: this.locationTemplate.fibrePulled,
                  equipmentInstalled: this.locationTemplate.equipmentInstalled,
                },
              };
              this.locationInfoWindowOpen = true;
            } else {
              this.addressInformation = {
                streetNumber: streetNumber.short_name,
                streetName: streetName.short_name,
              };
              this.addressPromptWindow = true;
            }
            this.zoom = 20;
          }
        } else {
          this.locationMarker = this.center;
          this.errorWindow = true;
        }
      });
    },
    reset() {
      this.detail.networkOperator = {};
      this.detail.selectedInternetPackage = "";
      this.max = 1;
      this.e1 = 1;
      this.chooseOperator = true;
      this.resetSec();
      this.resetBill();
      this.detail.primaryContact = {};
      this.detail.activationDate = "";
      this.detail.address.unitNumber = null;
      this.detail.address.fullUnitDetails = null;
      this.detail.address.estate = null;
      this.oopsModal = false;
      this.loadingAddressModal = false;
      this.foundLocationModal = false;
      this.locationMarker = {};
      this.errorWindow = false;
      this.locationInfo = {};
      this.networkData = {};
    },
    initialize() {
      this.getNetworkOperators();
      this.geolocate();
    },
    getNetworkOperators() {
      Api()
        .get("/networkOperators")
        .then((response) => {
          this.networkOperators = response.data;
        });
    },
    allowedDates: (val) => new Date(val).getDay() < 6 && new Date(val).getDay() > 0 && !disabledDates.includes(val),
    onEnd() {
      this.saveSignature();
    },
    addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      result.toISOString();
      return result;
    },
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    formatDate(date) {
      var dd = date.getDate();
      var mm = date.getMonth() + 1;
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      var yyyy = date.getFullYear();
      var result = yyyy + "-" + mm + "-" + dd;
      return result;
    },

    fetchEstates() {
      this.appLoading = true;
      this.loadingText = " \n\nFetching Available Networks...";
      Api()
        .get("/ftthApplication/isp/activelocationnetworks")
        .then(async (response) => {
          this.estateList = await response.data;
          let geoObj = {
            type: "FeatureCollection",
            name: "Network Polygons",
            crs: {
              type: "name",
              properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
            },
            features: [],
          };
          let objects = response.data;
          console.log(objects);
          for (let x = 0; x < objects.length; x++) {
            let obj = {
              type: "Feature",
              properties: {
                name: objects[x].name,
                fno: objects[x].organisation,
                network: objects[x],
                tessellate: 1,
              },
              geometry: {
                type: "Polygon",
                coordinates:
                  objects[x].networkPolygons && objects[x].networkPolygons.length > 0
                    ? JSON.parse(objects[x].networkPolygons[objects[x].networkPolygons.length - 1].coordinates)
                    : [],
              },
            };
            if (obj.geometry.coordinates.length > 0) {
              if (
                obj.geometry.coordinates[0][0][0] !==
                  obj.geometry.coordinates[0][obj.geometry.coordinates[0].length - 1][0] ||
                obj.geometry.coordinates[0][0][1] !==
                  obj.geometry.coordinates[0][obj.geometry.coordinates[0].length - 1][1]
              ) {
                obj.geometry.coordinates[0].push(obj.geometry.coordinates[0][0]);
              }
              geoObj.features.push(obj);
            }
          }
          this.geoData = geoObj;
          this.glookup = new GeoJsonGeometriesLookup(this.geoData);
          // this.plotMap();
          this.appLoading = false;
        });
    },

    setLocationInfoCard() {
      if (this.locationTemplate) {
        this.locationInfo = {
          address: this.locationTemplate.locationDescription,
          fno: this.detail.networkOperator,
          location: {
            fibrePulled: this.locationTemplate.fibrePulled,
            equipmentInstalled: this.locationTemplate.equipmentInstalled,
          },
        };
        this.locationMarker = this.center;
        this.locationInfoWindowOpen = true;
      }
    },
    setEstateList(e) {
      if (e) {
        this.appLoading = true;
        this.detail.selectedInternetPackage = null;
        this.detail.address = {};
        this.locationInfo = {};
        this.locationInfoWindowOpen = false;
        this.locationTemplate = null;
        this.detail.address.estate = null;
        Api()
          .get("/ftthApplication/isp/activelocationnetworks/" + e.id)
          .then((response) => {
            this.estateList = response.data;
            //  if (response.data.directNetworks.length > 0) {
            //       this.estateList = response.data.directNetworks;

            //     } else if (response.data.globalNetworks.length > 0) {
            //       this.estateList = response.data.globalNetworks;

            //     } else if(response.data.virtualNetworks.length > 0){
            //       this.estateList = response.data.virtualNetworks;

            //     }
            let geoObj = {
              type: "FeatureCollection",
              name: "Network Polygons",
              crs: {
                type: "name",
                properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
              },
              features: [],
            };
            let objects = this.estateList;
            for (let x = 0; x < objects.length; x++) {
              let obj = {
                type: "Feature",
                properties: {
                  name: objects[x].name,
                  // fno: objects[x].organisation,
                  network: objects[x],
                  tessellate: 1,
                },
                geometry: {
                  type: "Polygon",
                  coordinates:
                    objects[x].networkPolygons && objects[x].networkPolygons.length > 0
                      ? JSON.parse(objects[x].networkPolygons[objects[x].networkPolygons.length - 1].coordinates)
                      : [],
                },
              };
              if (obj.geometry.coordinates.length > 0) {
                if (
                  obj.geometry.coordinates[0][0][0] !==
                    obj.geometry.coordinates[0][obj.geometry.coordinates[0].length - 1][0] ||
                  obj.geometry.coordinates[0][0][1] !==
                    obj.geometry.coordinates[0][obj.geometry.coordinates[0].length - 1][1]
                ) {
                  obj.geometry.coordinates[0].push(obj.geometry.coordinates[0][0]);
                }
                geoObj.features.push(obj);
              }
            }
            this.geoData = geoObj;

            this.glookup = new GeoJsonGeometriesLookup(this.geoData);
            // this.plotMap();
            this.appLoading = false;
          });
      }
    },
    async setUnitList(e) {
      if (e) {
        let network = await this.estateList.find((x) => x.id === e);
        (this.locationTemplate = null), (this.detail.address.estate = e);
        this.networkData = network;
        if (!network.isMDU) {
          this.initMapAutocomplete(network);
        }
        if (network.geoLatitude && network.geoLongitude) {
          this.center = {
            lat: parseFloat(network.geoLatitude),
            lng: parseFloat(network.geoLongitude),
          };
        } else if (
          network.networkPolygons.length > 0 &&
          network.networkPolygons[network.networkPolygons.length - 1].coordinates
        ) {
          let coords = JSON.parse(network.networkPolygons[network.networkPolygons.length - 1].coordinates);
          this.center = {
            lat: coords[0][0][0],
            lng: coords[0][0][1],
          };
        }

        this.detail.address.unitNumber = null;
        this.detail.selectedInternetPackage = null;
        this.detail.internetPackageSelected = false;
        this.businessInstallFee = null;
        this.residentialInstallFee = null;
        let installFee = false;
        let run = true;
        this.unitList = network.locations;
        this.zoom = 18;
        this.detail.address.suburb = this.networkData.suburb;
        this.detail.address.streetName = this.networkData.streetName;
        this.detail.address.city = this.networkData.city;
        this.detail.selectedNetwork = this.networkData;
        this.installFee = this.networkData.routerInstallationFee;
        this.residentialInstallFee = this.networkData.residentialRouterInstallationFeeAmount;
        this.businessInstallFee = this.networkData.businessRouterInstallationFeeAmount;
        this.fetchPackages(e);
      }
    },
    selectUnit(obj) {
      this.selectUnitModal = false;
      this.detail.address.unitNumber = obj.locationDescription;
      this.detail.address.fullUnitDetails = obj;

      this.key += 1;
    },
    fetchPackages(e) {
      this.packagesLoading = true;
      this.loadingText = "Fetching Packages Available on Selected Network...";
      Api()
        .get("/ftthApplication/isp/byNetwork/active/" + e + "/" + this.detail.networkOperator.id)
        .then((response) => {
          this.packagesList = response.data.activePackages;
          this.pagination.totalItems = response.data.activePackages.length;

          this.flags.hasBusinessPacks = false;
          let find = response.data.activePackages.find(
            (x) => x.packagesFno.packagesFnoCat.packageCatType == "Business"
          );
          if (find) {
            this.flags.hasBusinessPacks = true;
          }
          this.loading = false;
          this.packagesLoading = false;
        });
    },
    checkForm() {
      if (this.detail.selectedInternetPackage !== null && typeof this.detail.selectedInternetPackage !== "undefined") {
        if (this.fnoPackagesPromoIdList.includes(this.detail.selectedInternetPackage.packagesFnoId)) {
          this.detail.selectedNetwork.residentialRouterInstallationFeeAmount = 0;
          this.detail.selectedNetwork.businessRouterInstallationFeeAmount = 0;
        }
      }
      let error = false;
      if (this.detail.selectedNetwork.gtuIncluded) {
        this.detail.includeTVOverFibrePackage = true;
      }
      // Activation date validation
      if (this.detail.activationDate == null || typeof this.detail.activationDate == "undefined") {
        this.errorMessage = "Please select an activation date.";
        this.e1 = 2;
        this.choosePackage = true;
        error = true;
      }
      // Primary contact Validation
      if (this.detail.primaryContact.firstName == "" || typeof this.detail.primaryContact.firstName == "undefined") {
        this.errorMessage = "You need to fill in your first name to proceed with submission.";
        this.e1 = 5;
        this.chooseContact = true;
        error = true;
      }
      if (this.detail.primaryContact.lastName == "" || typeof this.detail.primaryContact.lastName == "undefined") {
        this.errorMessage = "You need to fill in your last name to proceed with submission.";
        this.e1 = 5;
        this.chooseContact = true;
        error = true;
      }
      if (
        this.detail.primaryContact.contactNumber == "" ||
        typeof this.detail.primaryContact.contactNumber == "undefined"
      ) {
        this.errorMessage = "You need to fill in your contact number to proceed with submission.";
        this.e1 = 5;
        this.chooseContact = true;
        error = true;
      }
      if (this.detail.primaryContact.idNumber == "" || typeof this.detail.primaryContact.idNumber == "undefined") {
        this.errorMessage = "You need to fill in your ID number to proceed with submission.";
        this.e1 = 5;
        this.chooseContact = true;
        error = true;
      }
      if (
        this.detail.primaryContact.emailAddress == "" ||
        typeof this.detail.primaryContact.emailAddress == "undefined"
      ) {
        this.errorMessage = "You need to fill in your email address to proceed with submission.";
        this.e1 = 5;
        this.chooseContact = true;
        error = true;
      }
      // Secondary contact Validation
      if (this.detail.showSecondaryContact) {
        if (
          this.detail.secondaryContact.firstName == "" ||
          typeof this.detail.secondaryContact.firstName == "undefined"
        ) {
          this.errorMessage = "You need to fill in the secondary contact's first name to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (
          this.detail.secondaryContact.lastName == "" ||
          typeof this.detail.secondaryContact.lastName == "undefined"
        ) {
          this.errorMessage = "You need to fill in the secondary contact's last name to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (
          this.detail.secondaryContact.contactNumber == "" ||
          typeof this.detail.secondaryContact.contactNumber == "undefined"
        ) {
          this.errorMessage = "You need to fill in the secondary contact's contact number to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (
          this.detail.secondaryContact.emailAddress == "" ||
          typeof this.detail.secondaryContact.emailAddress == "undefined"
        ) {
          this.errorMessage = "You need to fill in the secondary contact's email address to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        //if (this.detail.secondaryContact.relationToPrimary == '' || typeof (this.detail.secondaryContact.relationToPrimary) == 'undefined') {
        //    this.errorMessage = "You need to fill in the secondary contact's relation to primary contact to proceed with submission."
        //    error = true
        //}
      }
      // Billing contact Validation
      if (this.detail.addBillingContact) {
        if (this.detail.billingContact.firstName == "" || typeof this.detail.billingContact.firstName == "undefined") {
          this.errorMessage = "You need to fill in the billing contact's first name to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (this.detail.billingContact.lastName == "" || typeof this.detail.billingContact.lastName == "undefined") {
          this.errorMessage = "You need to fill in the billing contact's last name to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (
          this.detail.billingContact.contactNumber == "" ||
          typeof this.detail.billingContact.contactNumber == "undefined"
        ) {
          this.errorMessage = "You need to fill in the billing contact's contact number to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (
          this.detail.billingContact.emailAddress == "" ||
          typeof this.detail.billingContact.emailAddress == "undefined"
        ) {
          this.errorMessage = "You need to fill in the billing contact's email address to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (this.detail.billingContact.idNumber == "" || typeof this.detail.billingContact.idNumber == "undefined") {
          this.errorMessage = "You need to fill in the billing contact's ID number to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (
          (this.detail.billingContact.physicalAddressLine1 == "" ||
            (typeof this.detail.billingContact.physicalAddressLine1 && !this.detail.billingAddressSame)) == "undefined"
        ) {
          this.errorMessage = "You need to fill in the billing contact's address line 1 to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (
          (this.detail.billingContact.physicalAddressLine2 == "" ||
            (typeof this.detail.billingContact.physicalAddressLine2 && !this.detail.billingAddressSame)) == "undefined"
        ) {
          this.errorMessage = "You need to fill in the billing contact's address line 2 to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (
          (this.detail.billingContact.physicalAddressLine3 == "" ||
            (typeof this.detail.billingContact.physicalAddressLine3 && !this.detail.billingAddressSame)) == "undefined"
        ) {
          this.errorMessage = "You need to fill in the billing contact's address line 3 to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        //if (this.detail.billingContact.vatNumber == '' || typeof (this.detail.billingContact.vatNumber) == 'undefined') {
        //    this.errorMessage = "You need to fill in the billing contact's VAT number to proceed with submission."
        //    error = true
        //}
      }
      // Address Validation
      if (this.detail.address.estate == "" || typeof this.detail.address.estate == "undefined") {
        this.errorMessage = "You need to fill in the address estate detail to proceed with submission.";
        this.e1 = 1;
        this.chooseEstate = true;
        error = true;
      }
      if (this.detail.address.unitNumber == "" || typeof this.detail.address.unitNumber == "undefined") {
        this.errorMessage = "You need to fill in the address unit number detail to proceed with submission.";
        this.e1 = 3;
        this.chooseAddress = true;
        error = true;
      }
      if (error === true) {
        this.showError = true;
        return false;
      } else {
        return true;
      }
    },
    getBase64Image(imgUrl, callback) {
      var img = new Image();

      // onload fires when the image is fully loadded, and has width and height

      img.onload = function() {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL("image/png"),
          dataURL = dataURL.replace(/^data:image\/(png|jpg);base64,/, "");

        return dataURL; // the base64 string
      };

      // set attributes and src
      img.setAttribute("crossOrigin", "anonymous"); //
      img.src = imgUrl;
    },
    submit() {
      if (this.checkForm()) {
        let base64String = "";
        this.detail.primaryContact.emailAddress = this.detail.primaryContact.emailAddress.replace(/\s/g, "");
        if (typeof this.detail.secondaryContact.emailAddress !== "undefined") {
          this.detail.secondaryContact.emailAddress = this.detail.secondaryContact.emailAddress.replace(/\s/g, "");
        }
        if (typeof this.detail.billingContact.emailAddress !== "undefined") {
          this.detail.billingContact.emailAddress = this.detail.billingContact.emailAddress.replace(/\s/g, "");
        }
        if (this.detail.selectedInternetPackage !== null) {
          if (this.detail.selectedInternetPackage.packagesFno.packagesFnoCat.packageCatType == "Business") {
            this.detail.isBusiness = true;
          } else {
            this.detail.isBusiness = false;
          }
          base64String = this.getBase64Image(this.detail.selectedInternetPackage.customerOrganisation.logo);
        }
        if (this.locationTemplate) {
          this.detail.supplierOrganisationId = this.locationInfo.fno.id;
          this.detail.streetNumber = this.locationTemplate.unitNo;
          this.detail.streetName = this.locationTemplate.complexStreetName;
        } else {
          this.detail.supplierOrganisationId = this.networkData.organisation.id;
          this.detail.streetNumber = this.addressInformation.streetNumber;
          this.detail.streetName = this.addressInformation.streetName;
        }
        this.detail.supplierOrganisationId = this.detail.networkOperator.id
        this.detail.organisationId = this.detail.networkOperator.id


        Api()
          .post("/ftthApplication/isp", {
            data: this.detail,
            ispLogo: base64String,
          })
          .then((response) => {
            this.addOrderButton = false;
            this.$emit("submitComplete");
          })
          .catch((error) => {
            const msg = error && error.response && error.response.data && error.response.data.message;
            alert(msg || "The order could not be submitted. Please try again.");
          });
      }
    },
    addOrderItem() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        this.reset();
        this.addOrderButton = true;
      }
    },
  },
};
</script>
<style>
.input-flex-min-space {
  padding: 0px;
  margin: 0px;
}
</style>
